
import { actions, types } from './requests'
export const GETCOLLECTIONLIST_TYPES = {
    ...types('GETCOLLECTIONLIST'),
}
export const GETCOLLECTIONLIST_ACTIONS = {
    ...actions('GETCOLLECTIONLIST'),
}